import { gql } from "@apollo/client"

export const DELETE_TAX_JAR_CONFIG = gql`
  mutation deleteTaxJarConfig($id: ID!) {
    deleteTaxJarConfig(id: $id) {
      status
    }
  }
`
